import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useI18n } from 'vue-i18n';
import i18n from '@/i18n.ts';
import { getFileSize } from '@/modules/common/utils/file-size.ts';

const PRECISION = 2;

export function formatFileSize(size: number | null | undefined) {
  if (size == null) {
    return '';
  }

  const { value, unit } = getFileSize(size);

  return `${i18n.global.n(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: PRECISION,
  })} ${i18n.global.t(unit)}`;
}

export function useFileSizeFormatter() {
  const { locale } = useI18n();

  function format(size: number | null | undefined) {
    void locale.value;
    return formatFileSize(size);
  }

  return { formatFileSize: format };
}

export function useFormattedFileSize(size: MaybeRefOrGetter<number | null | undefined>) {
  const { formatFileSize: format } = useFileSizeFormatter();

  return computed(() => format(toValue(size)));
}
